import React, { useState } from 'react';
import Sidebar from '../Includes/Sidebar';
import GeneralService from '../../services/general.service';
import Footer from '../Includes/Footer';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

export default function AddDoctor() {
    const [isLoading, setIsLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);

    const { values, errors, handleBlur, handleChange, handleSubmit, setFieldValue, resetForm } = useFormik({
        initialValues: {
            name: "",
            designation: "",
            specialization: "",
            degrees: "",
            gender: "",
            image: null
        },
        validate: (values) => {
            const errors = {};
            
            // Name validation
            if (!values.name) {
                errors.name = "Name is required";
            } else if (values.name.length > 255) {
                errors.name = "Name must be less than 255 characters";
            }
            
            // Designation validation
            if (values.designation && values.designation.length > 255) {
                errors.designation = "Designation must be less than 255 characters";
            }
            
            // Specialization validation
            if (values.specialization && values.specialization.length > 255) {
                errors.specialization = "Specialization must be less than 255 characters";
            }
            
            // Degrees validation
            if (values.degrees && values.degrees.length > 255) {
                errors.degrees = "Degrees must be less than 255 characters";
            }
            
            // Gender validation
            if (values.gender && !['male', 'female', 'other'].includes(values.gender)) {
                errors.gender = "Please select a valid gender";
            }
            
            // Image validation
            if (values.image) {
                const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'];
                const maxSize = 2048 * 1024; // 2MB in bytes
                
                if (!allowedTypes.includes(values.image.type)) {
                    errors.image = "Only JPG, JPEG, PNG, and WEBP files are allowed";
                } else if (values.image.size > maxSize) {
                    errors.image = "Image size must be less than 2MB";
                }
            }
            
            return errors;
        },
      // Simplified onSubmit handler - passes values to service
onSubmit: async (values, action) => {
    setIsLoading(true);
    try {
        // Debug: Log form values before sending
        console.log('Form values before submission:', values);
        
        // Validate that at least name is provided
        if (!values.name || !values.name.trim()) {
            toast.error("Name is required");
            setIsLoading(false);
            return;
        }

        // Add Doctor API Call - pass values object
        const response = await GeneralService.addDoctor(values);

        toast.success("Doctor added successfully");
        action.resetForm();
        setImagePreview(null);
        
        // Reset file input
        const fileInput = document.getElementById('image');
        if (fileInput) {
            fileInput.value = '';
        }
        
    } catch (err) {
        console.error("Error adding doctor:", err);
        toast.error(err.response?.data?.message || "Error adding doctor");
    }
    setIsLoading(false);
}

// Keep your original service function as is
    });

    // Handle image file selection
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFieldValue("image", file);
            
            // Create image preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setFieldValue("image", null);
            setImagePreview(null);
        }
    };

    // Remove selected image
    const removeImage = () => {
        setFieldValue("image", null);
        setImagePreview(null);
        // Reset file input
        document.getElementById('image').value = '';
    };

    return (
        <>
            <div className="content">
                <Sidebar />
                <div className="container-fluid pt-4 px-4">
                    <div className="bg-light text-center rounded p-4">
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0">Add New Doctor</h6>
                        </div>
                        <form onSubmit={handleSubmit} noValidate encType="multipart/form-data">
                            <div className='row'>
                                {/* Name Field */}
                                <div className='col-md-6'>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            id="name"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter doctor's name"
                                            required
                                        />
                                        <label htmlFor="name">Name *</label>
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>
                                </div>

                                {/* Designation Field */}
                                <div className='col-md-6'>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.designation ? 'is-invalid' : ''}`}
                                            id="designation"
                                            name="designation"
                                            value={values.designation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter designation"
                                        />
                                        <label htmlFor="designation">Designation</label>
                                        {errors.designation && <div className="invalid-feedback">{errors.designation}</div>}
                                    </div>
                                </div>

                                {/* Specialization Field */}
                                <div className='col-md-6'>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.specialization ? 'is-invalid' : ''}`}
                                            id="specialization"
                                            name="specialization"
                                            value={values.specialization}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter specialization"
                                        />
                                        <label htmlFor="specialization">Specialization</label>
                                        {errors.specialization && <div className="invalid-feedback">{errors.specialization}</div>}
                                    </div>
                                </div>

                                {/* Degrees Field */}
                                <div className='col-md-6'>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.degrees ? 'is-invalid' : ''}`}
                                            id="degrees"
                                            name="degrees"
                                            value={values.degrees}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter degrees (e.g., MBBS, MD)"
                                        />
                                        <label htmlFor="degrees">Degrees</label>
                                        {errors.degrees && <div className="invalid-feedback">{errors.degrees}</div>}
                                    </div>
                                </div>

                                {/* Gender Field */}
                                <div className='col-md-6'>
                                    <div className="form-floating mb-3">
                                        <select
                                            className={`form-control ${errors.gender ? 'is-invalid' : ''}`}
                                            id="gender"
                                            name="gender"
                                            value={values.gender}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">Other</option>
                                        </select>
                                        <label htmlFor="gender">Gender</label>
                                        {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
                                    </div>
                                </div>

                                {/* Image Upload Field */}
                                <div className='col-md-6'>
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Doctor Image</label>
                                        <input
                                            type="file"
                                            className={`form-control ${errors.image ? 'is-invalid' : ''}`}
                                            id="image"
                                            name="image"
                                            accept=".jpg,.jpeg,.png,.webp"
                                            onChange={handleImageChange}
                                        />
                                        <div className="form-text">Max size: 2MB. Allowed formats: JPG, JPEG, PNG, WEBP</div>
                                        {errors.image && <div className="invalid-feedback">{errors.image}</div>}
                                    </div>
                                </div>

                                {/* Image Preview */}
                                {imagePreview && (
                                    <div className='col-md-12'>
                                        <div className="mb-3">
                                            <label className="form-label">Image Preview</label>
                                            <div className="image-preview-container">
                                                <img
                                                    src={imagePreview}
                                                    alt="Doctor Preview"
                                                    className="image-preview"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger remove-image-btn"
                                                    onClick={removeImage}
                                                >
                                                    <i className="fas fa-times"></i> Remove
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Submit Button */}
                                <div className="col-md-12 d-flex">
                                    <button
                                        className="btn btn-submit"
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? "Submitting..." : "Add Doctor"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <Footer />
            </div>
            <style jsx>{`
                .btn-submit {
                    background-color: #f44c00;
                    border-color: #f44c00;
                    padding: 14px 28px;
                    font-size: 16px;
                    font-weight: 600;
                    text-transform: uppercase;
                    border-radius: 30px;
                    transition: background-color 0.3s, border-color 0.3s;
                    display: inline-block;
                    margin-top: 10px;
                    color: #fff;
                }

                .btn-submit:hover {
                    background-color: #d43f00;
                    border-color: #d43f00;
                    color: #fff;
                }

                .btn-submit:focus {
                    outline: none;
                }

                .image-preview-container {
                    position: relative;
                    display: inline-block;
                }

                .image-preview {
                    max-width: 200px;
                    max-height: 200px;
                    border-radius: 8px;
                    border: 2px solid #dee2e6;
                    object-fit: cover;
                }

                .remove-image-btn {
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0;
                }

                .invalid-feedback {
                    display: block;
                }
            `}</style>
        </>
    );
}